import Api from "../../Services/Api";
import { toastr } from "react-redux-toastr";
export const TENANATNAME = "riskwell/userform/TENANATNAME";
export const TENANTROLE = "riskwell/userform/TENANTROLE";
export const TENANTJOBTITLE = "riskwell/userform/TENANTJOBTITLE";
export const TENANTEMAIL = "riskwell/userform/TENANTEMAIL";
export const TENANTPHONE = "riskwell/userform/TENANTPHONE";
export const TENANTPASSWORD = "riskwell/userform/TENANTPASSWORD";
export const RESETDATA = "riskwell/userform/RESETDATA";
export const LOGGEDINLOADER = "riskwell/userform/LOGGEDINLOADER";
export const USERCREATIONFAILURE = "riskwell/userform/USERCREATIONFAILURE";
export const WORKSTREAMDATA = "riskwell/fetch/WORKSTREAMDATA";
export const WORKSTREAMIDS="riskwell/userform/WORKSTREAMIDS";
export const ISTENANTADMIN = "riskwell/userform/ISTENANTADMIN";
export const tenantName = (name) => {
  return {
    type: TENANATNAME,
    payload: name,
  };
};

export const tenantRole = (rol) => {
  return {
    type: TENANTROLE,
    payload: rol,
  };
};

export const tenantJobTitle = (job) => {
  return {
    type: TENANTJOBTITLE,
    payload: job,
  };
};

export const tenantEmail = (mail) => {
  return {
    type: TENANTEMAIL,
    payload: mail,
  };
};

export const tenantPhone = (phone) => {
  return {
    type: TENANTPHONE,
    payload: phone,
  };
};

export const tenantPassword = (pwd) => {
  return {
    type: TENANTPASSWORD,
    payload: pwd,
  };
};

export const isTenantAdmin = (isTenantAdmin) => {
  return {
    type: ISTENANTADMIN,        
    payload: isTenantAdmin,
  };
};

export const workStreamIds = (ids) => {
  return {
    type: WORKSTREAMIDS,
    payload: ids,
  };
};

export const resetData = () => {
  return {
    type: RESETDATA,
  };
};

export const loggedInLoader = (bool) => {
  return {
    type: LOGGEDINLOADER,
    payload: bool,
  };
};

export const UserCreationFailure = (err) => {
  return {
    type: USERCREATIONFAILURE,
    payload: err,
  };
};


export const workstreamData = (Data) => {
  return {
    type: WORKSTREAMDATA,
    payload: Data,
  };
};

export const userAddingByAdmin = (params) => async (dispatch) => {
  try {
    dispatch(loggedInLoader(true));
    let result = await Api.userAddByTenant(params);
    dispatch(loggedInLoader(false));
    if (result.status === 200) {
      dispatch(resetData());
      toastr.success(result.message);
    } 
    // else if (result.status === "Unauthorized") {
    //   dispatch(UserCreationFailure(result.status));
    //   toastr.error(result.message);
    // } 
    else {
      toastr.error(result.message);
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    toastr.error("Error in User Creation");
  }
};

export const updateUserAddingByAdmin = (params) => async (dispatch) => {
  try {
    dispatch(loggedInLoader(true));
    let result = await Api.userUpdateByTenant(params);
    dispatch(loggedInLoader(false));
    if (result.status === 200) {
      dispatch(resetData());
      toastr.success("User Updated");
      
    } 
    // else if (result.statusText === "Unauthorized") {
    //   dispatch(UserCreationFailure(result.statusText));
    //   toastr.error(result.statusText);
    // }
     else {
      toastr.error(result.message ? result.message : "User Update Failed");
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    toastr.error("Error in User Creation");
  }
};

 export const getOrganizationsUnits = (params) => async (dispatch) => {

   try {
      dispatch(loggedInLoader(true));
     let response = await Api.getOrgUnits(params);
     dispatch(loggedInLoader(false));
      if (response.status === 200) {
        dispatch(workstreamData(response.organisationUnit));
      } else {
       dispatch(workstreamData([]));
      }
    } catch (error) {
      dispatch(loggedInLoader(false));
      console.error(error)
    }
  };
